
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  folderListNestedHeading: {
    id: "FolderListNestedHeading.test",
    defaultMessage: "Construction Phases"
  },
  folderListHeading: {
    id: "FolderListHeading.text",
    defaultMessage: "Folders",
  }, 
  folderListHeadingAll: {
    id: "FolderListHeadingAll.text",
    defaultMessage: "All Folders",
  }, 
  folderListNone: {
    id: "FolderListNone.text",
    defaultMessage: "No folders available yet",
  }, 
  folderListSeeAll: {
    id: "FolderListSeeAll.text",
    defaultMessage: "See all folders",
  },
  folderListToday: {
    id: "FolderListToday.text",
    defaultMessage: "Today"
  },
  folderList7Days: {
    id: "FolderList7Days.text",
    defaultMessage: "Last 7 Days"
  },
  folderList30Days: {
    id: "FolderList30Days.text",
    defaultMessage: "Last 30 Days"
  },
  folderListSortByDate: {
    id: "FolderList.SortByDate",
    defaultMessage: "Sort by Date"
  },
  folderListSortByName: {
    id: "FolderList.SortByName",
    defaultMessage: "Sort by Name"
  }
});

export default MESSAGES;